import { ScheduleRule } from "./ScheduleTableRow";
import { ScheduleDayOfWeek } from "@/api/schedules";

// Define chronological order of days (Monday = 0, Tuesday = 1, etc.)
const dayOrder: Record<ScheduleDayOfWeek, number> = {
	[ScheduleDayOfWeek.Monday]: 0,
	[ScheduleDayOfWeek.Tuesday]: 1,
	[ScheduleDayOfWeek.Wednesday]: 2,
	[ScheduleDayOfWeek.Thursday]: 3,
	[ScheduleDayOfWeek.Friday]: 4,
	[ScheduleDayOfWeek.Saturday]: 5,
	[ScheduleDayOfWeek.Sunday]: 6,
};

/**
 * Sort schedule rules by day, then by start time, then by end time, then by end date, then by ID. Used to prevent schedules jumping around when saving.
 */
export function sortScheduleRules(scheduleRules: ScheduleRule[]): ScheduleRule[] {
	return scheduleRules.sort((a, b) => {
		if (a.day !== b.day) {
			return dayOrder[a.day] - dayOrder[b.day];
		}
		if (a.startTime.hour !== b.startTime.hour) {
			return a.startTime.hour - b.startTime.hour;
		}
		if (a.startTime.minute !== b.startTime.minute) {
			return a.startTime.minute - b.startTime.minute;
		}
		if (a.endTime.hour !== b.endTime.hour) {
			return a.endTime.hour - b.endTime.hour;
		}
		if (a.endTime.minute !== b.endTime.minute) {
			return a.endTime.minute - b.endTime.minute;
		}
		if (a.endDate.getTime() !== b.endDate.getTime()) {
			return a.endDate.getTime() - b.endDate.getTime();
		}
		return a.id - b.id;
	});
}
